module.exports = __webpack_public_path__ + "img/img-3-9.66675fe3.png";